<template>
  <!-- @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-SIDENAV-REACTIVE-001 — dead DOM 조작/listener/method 청소 (주석 header, $route watch, resize listener, handleResize/menuBtnFunction/handleDeviceChange 제거) -->
  <!-- @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-HEADER-LAYOUT-001 Phase C — LocaleSwitcher 사이드바에서 제거. 단일 진입점: AppHeader(데스크탑) + mobile_header-right(모바일). -->
  <aside
    id="new-sidenav"
  >
    <div class="sidenav-userinfo-container">
      <img
        v-if="userInfo.imgUrl"
        :src="userInfo.imgUrl"
        class="user-logo"
        alt="main_logo"
      />
      <img
        v-else
        src="@/assets/img/profile_df.png"
        class="user-logo"
        alt="main_logo"
      />
      <div class="user-info-text">
        <div class="hospital-name">
          {{ userInfo.companyName }}
        </div>
        <div class="manager-name">
          {{ userInfo.username }}
        </div>
      </div>
    </div>

    <sidenav-list 
      :menu="menu"
    />
    <div class="sidenav-footer-container">
      <div
        class="sidenav-item-container"
        @click="signOut"
      >
        <div class="sidenav-item-icon">
          <img src="@/assets/img/sidenav/signout.svg">
        </div>
        <div class="sidenav-item-text">
          {{ $t('navbar_signout') }}
        </div>
      </div>
    </div>
  </aside>
</template>
<script>
import SidenavList from './SidenavList.vue';
import { twoBtnDialog, oneBtnDialog, } from '@/utils/utils';
import { abortLocalePatch } from '@/apis/account.js';
import lotStatusApi from '@/apis/lotStatus';

export default {
  name: 'index',
  components: {
    SidenavList,
  },
  // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-MOBILE-SIDENAV-001 hotfix — props.class 제거 (Vue 3 fallthrough attribute 차단 해제)
  //   기존: props.class 정의가 App.vue의 :class binding을 prop으로 가로채 root <aside id="new-sidenav">에 forward 차단
  //   결과: .active 클래스 추가 효과 0 → 모바일 사이드바 펼침 안 됨
  //   현재: props 제거 → Vue fallthrough가 자동 동작, :class binding이 root element에 정상 적용
  //   사용처 0건 검증 완료 (template/script 어디서도 this.class 참조 없음)
  data() {
    return {
      logo: '',
      company: '',
      manager: '',
      userInfo: {
        username: '',
        imgUrl: '',
        companyName: '',
        userId: '',
        locale: '',
      },
      // REQ-FE-DASH-002a: BE endpoint 가용성 precheck 상태 (session-scoped)
      // null=미확인, true=available, false=unavailable
      lotFlowAvailable: null,
      _lotFlowPrecheckDone: false,
    };
  },
  computed: {
    computedUserInfo() {
      return this.$store.getters.getUserInfo;
    },
    // @MX:NOTE: SPEC-CHINA-ADMIN-LOCALE-M3-FIX — store.state.privileges.category reactive 구독.
    // 이전: data().menu 복사 → M3 watcher가 store 갱신해도 local copy 그대로 → 사이드바 미반응.
    menu() {
      const info = this.$store.getters.getPrivilegesInfo;
      const rawMenu = Array.isArray(info?.category) ? info.category : [];
      // REQ-FE-DASH-002a: lotFlowAvailable=false 이면 /lot-status 메뉴 항목 제거
      // lotFlowAvailable=null(미확인)이면 optimistic hide-until-200 → 숨김
      if (this.lotFlowAvailable !== true) {
        return rawMenu.map((category) => ({
          ...category,
          menu: (category.menu || []).filter((item) => item.link !== '/lot-status'),
        })).filter((category) => (category.menu || []).length > 0 || !category.menu);
      }
      return rawMenu;
    },
  },
  mounted() {
    // REQ-FE-DASH-002a: 사이드바 mount 시 HEAD precheck (비차단, session 1회)
    this._runLotFlowPrecheck();
  },
  watch: {
    computedUserInfo: {
      handler(newValue, oldValue) {
        if(newValue.username) this.userInfo.username = newValue.username;
        if(newValue.imgUrl) this.userInfo.imgUrl = newValue.imgUrl;
        if(newValue.companyName) this.userInfo.companyName = newValue.companyName;
        if(localStorage.getItem('CompanyInfo')) {
          const companyInfo = JSON.parse(localStorage.getItem('CompanyInfo'));
          this.userInfo.companyName = companyInfo?.name;
          this.userInfo.imgUrl = companyInfo?.imgUrl;
        }
        if(newValue.userId) this.userInfo.userId = newValue.userId;
        if(newValue.locale){
          this.userInfo.locale = newValue.locale;
        }
        this.getSideNavContent();
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    // @MX:NOTE: [AUTO] REQ-FE-DASH-002a — HEAD /lot-status/dashboard precheck (session-scoped, 비차단)
    //   200이면 lotFlowAvailable=true (메뉴 노출)
    //   404/503/network error이면 false (메뉴 숨김)
    //   401이면 token refresh 후 재시도 (REQ-FE-DASH-002b)
    async _runLotFlowPrecheck() {
      if (this._lotFlowPrecheckDone) return;
      this._lotFlowPrecheckDone = true;
      try {
        await lotStatusApi.precheckDashboard();
        this.lotFlowAvailable = true;
      } catch (err) {
        const status = err?.response?.status;
        if (status === 401) {
          // REQ-FE-DASH-002b: 401 → token refresh 후 재시도 (기존 interceptor가 refresh 처리)
          // chinaInapi interceptor가 자동 refresh+retry 처리하므로 여기서 재시도하면 이미 refreshed token
          // interceptor retry 후 다시 401이면 unavailable 처리
          this.lotFlowAvailable = false;
          // reset for potential re-try after login refresh
          this._lotFlowPrecheckDone = false;
        } else {
          // 404/503/network error → 안전 기본값 hide
          this.lotFlowAvailable = false;
        }
      }
    },

    async getSideNavContent() {
      // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-SIDEBAR-CONSOLID-001 — dispatch 시그니처 정리 (3번째 인자 제거), throw catch silent (빈 메뉴 처리)
      try {
        await this.$store.dispatch('getPrivileges', this.userInfo.userId);
      } catch (error) {
        console.log(error);
        // silent — 빈 메뉴로 처리 (사이드바 로드 실패 시 기존 동작 보존)
      }
      // @MX:NOTE: SPEC-CHINA-ADMIN-LOCALE-M3-FIX — local copy 제거, computed menu()가 reactive 구독.
    },
    async signOut() {
      const confirmResult = await twoBtnDialog(this.$t('navbar_signout'), this.$t('navbar_signout_confirm'), this.$t('common_confirm'), this.$t('common_cancel'));
      if(confirmResult) {
        // REQ-LOCALE-FE-014: in-flight PATCH abort (orphan toast 방지)
        abortLocalePatch();
        // REQ-LOCALE-FE-010: locale 초기화 — state+i18n+document.lang 동시(resetLocale 액션 경유).
        // 종전엔 RESET 뮤테이션만 커밋해 i18n이 직전 언어로 남는 분열이 있었다(localStorage는 보존 — R-11).
        this.$store.dispatch('locale/resetLocale');
        // FE-D5 patch: 옛 키 'locale'은 이미 제거됨 (legacy SPEC-CHINA-ADMIN-LOCALE-CORE-001 정리). admin_china_locale은 R-11/REQ-FE-010에 따라 보존.
        await this.$store.dispatch('clearLocalStorage');
        window.checkIsLoggedIn({
          isLoggedIn:false,
          accessToken:null,
          refreshToken:null,
        });
        this.$router.push('/signin');
        document.querySelector('body').classList.remove('modal-open');
      }
    },
  },
};
</script>

<style scoped lang="scss">
   
.menu-btn {
    height: 32px;
    width: 40px;
    cursor: pointer;
}

.menu-btn span,
.menu-btn span::before,
.menu-btn span::after {
    background: #ffd814; 
    content: '';
    position: absolute;
    width: 40px;
    height: 6px;         
    margin-top: 13px;
    
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -o-transform: rotate(deg);
    transform: rotate(180deg);

    -webkit-transition: .5s ease-in-out;
    -moz-transition: .5s ease-in-out;
    -o-transition: .5s ease-in-out;
    transition: .5s ease-in-out;
}

.menu-btn span::before {
    margin-top:-12px;
}

.menu-btn span::after {
    margin-top:12px;
}

.menu-btn.active span {
    background: transparent;
}

.menu-btn.active span::before {
    margin-top: 0;

    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
}

.menu-btn.active span::after {
    transform: rotate(-45deg);
    margin-top: 0;
}
</style>
